export const FETCH_PRODUCT_REPORTS_START = "FETCH_PRODUCT_REPORTS_START";
export const FETCH_PRODUCT_REPORTS_SUCCESS = "FETCH_PRODUCT_REPORTS_SUCCESS";
export const FETCH_PRODUCT_REPORTS_ERROR = "FETCH_PRODUCT_REPORTS_ERROR";
